const cryptoWords1: string[] = [
  "Bit",
  "Crypto",
  "Blockchain",
  "Byte",
  "Coin",
  "HODL",
  "Altcoin",
  "Laughing",
  "Ethereum",
  "Crypto",
  "Chuckle",
  "Ripple",
  "Laughing",
  "NFT",
  "Crypto",
  "Doge",
  "Bitcoin",
  "Lite",
  "Crypto",
  "Blockchain",
];

const cryptoWords2: string[] = [
  "Wit",
  "Crackups",
  "Banter",
  "Sized",
  "Comedians",
  "Humorists",
  "Antics",
  "Ledgers",
  "Eccentrics",
  "Jesters",
  "Chain",
  "Rascals",
  "Lambo",
  "Nutters",
  "Cacklers",
  "Jokers",
  "Buffs",
  "Laughs",
  "Quips",
  "Buffs",
];

const cryptoWords3: string[] = [
  "Exchange",
  "Penny",
  "Vault",
  "Dollar",
  "Lambo",
  "HODLer",
  "Whale",
  "Pump",
  "Dump",
  "FOMO",
  "FUD",
  "Moon",
  "Rocket",
  "Bag",
  "Shill",
  "Ponzi",
  "Bear",
  "Bull",
  "Satoshi",
  "Hash",
];

export function generateRandomChatName(): string {
  const randomIndex1: number = Math.floor(Math.random() * cryptoWords1.length);
  const randomIndex2: number = Math.floor(Math.random() * cryptoWords2.length);
  const randomIndex3: number = Math.floor(Math.random() * cryptoWords3.length);

  // Ensure that the same word is not picked from the same index twice
  const indexArray = [randomIndex1, randomIndex2, randomIndex3];
  const uniqueIndexes = Array.from(new Set(indexArray));

  // If any word is picked from same index, it will be replaced with a random index.
  const index1 = uniqueIndexes[0];
  const index2 =
    uniqueIndexes.length > 1
      ? uniqueIndexes[1]
      : Math.floor(Math.random() * cryptoWords2.length);
  const index3 =
    uniqueIndexes.length > 2
      ? uniqueIndexes[2]
      : Math.floor(Math.random() * cryptoWords3.length);

  return cryptoWords1[index1] + cryptoWords2[index2] + cryptoWords3[index3];
}
